import { render, staticRenderFns } from "./SelectedDateProperties.vue?vue&type=template&id=4d1a701a&scoped=true"
import script from "./SelectedDateProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectedDateProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SelectedDateProperties.vue?vue&type=style&index=0&id=4d1a701a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1a701a",
  null
  
)

export default component.exports